module.exports = __webpack_public_path__ + "img/paraguai.59753754.png";